import React from 'react'
import Alltutors from '../../Components/admin/Alltutors'
function AllTutors() {
  return (
    <div>
      <Alltutors/>
    </div>
  )
}

export default AllTutors
